import { useResizeObserver, ResizeObserverEntry } from '../../internal/hooks/container-queries';
import { useCallback } from 'react';

const extractHeight = (rect: ResizeObserverEntry) => rect?.borderBoxSize[0].blockSize;

export function useObservedElement(selector: string) {
  const getElement = useCallback<() => HTMLElement | null>(() => document.querySelector(selector), [selector]);
  return useResizeObserver(getElement, extractHeight) ?? 0;
}
